module.exports = __webpack_public_path__ + "assets/img/shortsPlatform-experience.cc68f62a.png";